import { withTranslation } from 'react-i18next';

import Header from 'components/ui/Header';
import ExploreList from 'components/explore/ExploreList';
import CategoryMenu from 'components/bots/CategoryMenu';
import RequestBotButton from 'components/explore/RequestBotButton';
import FilterMenu from 'components/explore/FilterMenu';

const ExplorePage = ({ t }) => {
  return (
    <>
      <Header>
        <div className="d-flex align-items-center justify-content-between">
          <div>
            <h1 className="m-0 p-0 fw-lighter">{t('explore.title')}</h1>
          </div>

          <div>
            <RequestBotButton className="btn btn-outline-light" />
          </div>
        </div>
      </Header>

      <div className="mt-5 container d-flex justify-content-between" id="explore-page">
        <section className="section pe-5" style={{ minWidth: 300 }}>
          <h6 className="mb-3 text-muted">{t('explore.categories.title')}</h6>
          <CategoryMenu />

          <h6 className="mt-5 mb-3 text-muted">{t('keys.filters')}</h6>
          <FilterMenu />
        </section>

        <section className="section ms-5 flex-fill">
          <ExploreList />

          <div className="mt-5 mb-5">
            <div style={{ maxWidth: 200, margin: 'auto' }}>
              <hr />
            </div>
            <h3 className="text-center fw-lighter">{t('explore.no_entries')}</h3>
            <div className="text-center mt-4">
              <RequestBotButton />
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default withTranslation()(ExplorePage);
